export interface Webtoon {
  id: number;
  slug: string;
  title: string;
  category: string;
  author: string;
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  likes: number;
  tags: string[];
  episode: number;
  updateDay: string;
  cover: string;
  shortDesc: string;
  synopsis: string;
  featured?: boolean;
}

export const webtoons: Webtoon[] = [
  {
    id: 1,
    slug: "xi-ai-jie-dao",
    title: "喜爱街道",
    category: "sweet",
    author: "南有町",
    status: "连载中",
    rating: 9.6,
    views: "4280万",
    likes: 12800,
    tags: ["甜宠", "欢喜冤家", "日常"],
    episode: 128,
    updateDay: "每周五更新",
    cover: "https://readdy.ai/api/search-image?query=A%20warm%20coral%20and%20cream%20webtoon%20cover%20illustration%20of%20a%20smiling%20young%20couple%20standing%20on%20a%20cozy%20sunlit%20street%2C%20soft%20round%20cartoon%20style%2C%20gentle%20glowing%20lights%2C%20sweet%20romantic%20atmosphere%2C%20clean%20minimal%20background%2C%20bright%20and%20happy%20mood&width=600&height=860&seq=hanman-cover-01&orientation=portrait",
    shortDesc: "邻家女孩与毒舌房东的契约同居,糖分拉满的日常甜宠。",
    synopsis: "被房东赶出出租屋的普通上班族林小满,意外和毒舌又傲娇的房东顾迟签下「同居协议」。从互相看不顺眼到悄悄心动,在同一条街道的日常里,两颗心一点点靠近。没有狗血误会,只有恰到好处的暧昧和治愈系甜度,是看完会嘴角上扬的存在。",
    featured: true,
  },
  {
    id: 2,
    slug: "yue-guang-zhi-zhong",
    title: "月光之种",
    category: "fantasy",
    author: "白夜信使",
    status: "连载中",
    rating: 9.4,
    views: "3560万",
    likes: 10200,
    tags: ["奇幻", "魔法", "冒险"],
    episode: 96,
    updateDay: "每周三更新",
    cover: "https://readdy.ai/api/search-image?query=A%20dreamy%20fantasy%20webtoon%20cover%20illustration%20of%20a%20young%20mage%20holding%20a%20glowing%20moonflower%20in%20a%20starlit%20forest%2C%20teal%20and%20gold%20magical%20glow%2C%20intricate%20cartoon%20style%2C%20ethereal%20atmosphere%2C%20dark%20floral%20background&width=600&height=860&seq=hanman-cover-02&orientation=portrait",
    shortDesc: "少女从月光中拾得种子,踏上拯救破落王国的奇幻旅程。",
    synopsis: "灵力衰微的大陆上,传说只有「月光之种」能唤醒沉睡的古神。平凡少女苏念在一次月食之夜意外与种子建立联系,被迫卷入王权纷争与神谕预言。她将集结忠犬骑士、傲娇魔女与神秘旅人,在魔法与阴谋交织的世界里,寻找自己的答案。",
    featured: true,
  },
  {
    id: 3,
    slug: "hui-yi-zhi-cheng",
    title: "回忆之城",
    category: "drama",
    author: "灰岛川",
    status: "已完结",
    rating: 9.7,
    views: "6120万",
    likes: 18300,
    tags: ["剧情", "催泪", "人性"],
    episode: 152,
    updateDay: "已完结",
    cover: "https://readdy.ai/api/search-image?query=A%20poignant%20drama%20webtoon%20cover%20illustration%20of%20a%20solitary%20figure%20walking%20down%20a%20rainy%20empty%20city%20street%20at%20dusk%2C%20amber%20and%20grey%20moody%20lighting%2C%20emotional%20cinematic%20cartoon%20style%2C%20reflective%20atmosphere&width=600&height=860&seq=hanman-cover-03&orientation=portrait",
    shortDesc: "一座能回收「遗忘记忆」的城市,一段关于失去与和解的催泪史诗。",
    synopsis: "在回忆之城,人们可以把痛苦的记忆交给「记忆回收站」换取忘记。记忆修复师阿泽每天帮别人遗忘,却始终无法忘记多年前失踪的妹妹。直到某天,一份写着妹妹名字的记忆档案出现,他踏上了一场关于爱、罪与救赎的寻回之旅。",
  },
  {
    id: 4,
    slug: "hei-an-mo-pan",
    title: "黑暗棋盘",
    category: "suspense",
    author: "冷川弈",
    status: "连载中",
    rating: 9.5,
    views: "2940万",
    likes: 8700,
    tags: ["悬疑", "推理", "犯罪"],
    episode: 84,
    updateDay: "每周六更新",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20suspense%20webtoon%20cover%20illustration%20of%20a%20shadowy%20detective%20silhouette%20beside%20a%20glowing%20chess%20board%20in%20a%20dim%20room%2C%20deep%20charcoal%20and%20red%20accents%2C%20moody%20dramatic%20cartoon%20style%2C%20tense%20atmosphere&width=600&height=860&seq=hanman-cover-04&orientation=portrait",
    shortDesc: "天才棋手转行刑警,用棋局思维破解连环案件。",
    synopsis: "前围棋天才沈弈在一场暗杀中失去挚友,转行成为刑警。他坚信所有案件都是一盘被人操控的棋,而凶手是最强的棋手。每一桩看似无关的案子,背后都连着同一只黑手。他和搭档并肩追查,却发现自己也是棋盘上的一枚棋子。",
    featured: true,
  },
  {
    id: 5,
    slug: "qi-ji-ban-de-mo-fa",
    title: "奇迹班的神祇",
    category: "campus",
    author: "小柚汽水",
    status: "连载中",
    rating: 9.1,
    views: "1880万",
    likes: 6400,
    tags: ["校园", "轻松", "友情"],
    episode: 60,
    updateDay: "每周二更新",
    cover: "https://readdy.ai/api/search-image?query=A%20bright%20campus%20webtoon%20cover%20illustration%20of%20happy%20high%20school%20students%20in%20uniforms%20with%20notebooks%20and%20pencils%2C%20fresh%20teal%20and%20cream%20palette%2C%20playful%20clean%20cartoon%20style%2C%20cheerful%20school%20atmosphere&width=600&height=860&seq=hanman-cover-05&orientation=portrait",
    shortDesc: "全校最差班级,迎来一位能「创造奇迹」的转学生。",
    synopsis: "因故转学的学霸程澈空降全校闻名的差班「奇迹班」。他不按常理出牌,用奇奇怪怪的方法帮助同学解决各种青春难题:考试、暗恋、家庭矛盾……这个看似散漫的少年,其实背负着不为人知的秘密。一群「问题少年」的热血校园日常,温暖又爆笑。",
  },
  {
    id: 6,
    slug: "cheng-du-dang-ji",
    title: "城都档案",
    category: "action",
    author: "铁与刃",
    status: "连载中",
    rating: 9.3,
    views: "3760万",
    likes: 11500,
    tags: ["热血", "战斗", "复仇"],
    episode: 110,
    updateDay: "每周日更新",
    cover: "https://readdy.ai/api/search-image?query=A%20high-energy%20action%20webtoon%20cover%20illustration%20of%20a%20determined%20fighter%20holding%20a%20glowing%20blade%20with%20dynamic%20fire%20effects%2C%20intense%20orange%20and%20charcoal%20palette%2C%20bold%20dramatic%20cartoon%20style%2C%20explosive%20energy&width=600&height=860&seq=hanman-cover-06&orientation=portrait",
    shortDesc: "沦为废弃之地的城都,一名少年以拳脚为众人开辟新生。",
    synopsis: "资源枯竭的城都沦为强者为王的无法地带。为夺回被黑帮占据的家园,少年曜与姐姐一起经营着小小的拳馆。当姐姐被卷入黑暗交易后,曜决定以双拳硬撼整个城都的秩序。一场关于信念、血性与重生的高燃战斗就此展开。",
    featured: true,
  },
  {
    id: 7,
    slug: "chun-guang-liao-ren",
    title: "春光撩人",
    category: "romance",
    author: "酥梨酱",
    status: "连载中",
    rating: 9.2,
    views: "2410万",
    likes: 7900,
    tags: ["恋爱", "职场", "都市"],
    episode: 72,
    updateDay: "每周四更新",
    cover: "https://readdy.ai/api/search-image?query=A%20refined%20romance%20webtoon%20cover%20illustration%20of%20a%20stylish%20working%20woman%20and%20a%20suit%20man%20in%20a%20modern%20city%20plaza%20at%20spring%2C%20soft%20coral%20and%20warm%20cream%2C%20elegant%20adult%20cartoon%20style%2C%20tender%20sophisticated%20mood&width=600&height=860&seq=hanman-cover-07&orientation=portrait",
    shortDesc: "职场女强人与她名义上的「合约男友」,一场蓄谋已久的成年心动。",
    synopsis: "被催婚多年的广告总监季春晓,为了应付家庭聚会,请来冷静克制的年轻律师做「合约男友」。可这场原本各取所需的合作,却因一次次若即若离的试探而逐渐越界。都市职场下的成熟恋爱,克制又暧昧,张力十足。",
  },
  {
    id: 8,
    slug: "mian-bao-wu-de-zhu-gong",
    title: "面包屋的午光",
    category: "healing",
    author: "云朵面包",
    status: "已完结",
    rating: 9.5,
    views: "2030万",
    likes: 7100,
    tags: ["治愈", "温情", "日常"],
    episode: 88,
    updateDay: "已完结",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20healing%20webtoon%20cover%20illustration%20of%20a%20warm%20bakery%20with%20fresh%20bread%20and%20a%20gentle%20smiling%20shopkeeper%2C%20soft%20golden%20and%20cream%20tones%2C%20soothing%20gentle%20cartoon%20style%2C%20calm%20comforting%20atmosphere&width=600&height=860&seq=hanman-cover-08&orientation=portrait",
    shortDesc: "街角小面包屋里,每一次出炉都治愈着来往的失意灵魂。",
    synopsis: "在城市角落,有一家只在午后开门的小面包屋。失意的青年、迷茫的画家、独居的老人……每个推门进来的人,都带着自己的心事。老板娘总是笑着递上一块刚出炉的面包,和一句恰到好处的温柔。慢节奏的治愈系作品,看完像被暖阳晒过。",
  },
  {
    id: 9,
    slug: "shou-bing-de-xin-dong",
    title: "手绘的心动",
    category: "sweet",
    author: "奶油栗子",
    status: "连载中",
    rating: 9.0,
    views: "1560万",
    likes: 5200,
    tags: ["甜宠", "校园", "暗恋"],
    episode: 54,
    updateDay: "每周一更新",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20school%20webtoon%20cover%20illustration%20of%20a%20shy%20girl%20sketching%20in%20a%20notebook%20while%20a%20gentle%20boy%20watches%20her%2C%20soft%20pink%20and%20cream%2C%20delicate%20cute%20cartoon%20style%2C%20innocent%20heartwarming%20mood&width=600&height=860&seq=hanman-cover-09&orientation=portrait",
    shortDesc: "美术社少女的速写本里,偷偷画满了同一个人的侧脸。",
    synopsis: "美术社的安静女孩夏栀,把暗恋的校篮球队长画满了整本速写本。某天画册意外掉落,被当事人捡到。原本以为会被嘲笑,没想到对方红着脸说:「你画得……真好看。」一场由速写本开启的双向暗恋,甜度满分。",
  },
  {
    id: 10,
    slug: "wang-wang-de-tian-xi",
    title: "万王的天梯",
    category: "fantasy",
    author: "炼金之子",
    status: "连载中",
    rating: 9.4,
    views: "2890万",
    likes: 8300,
    tags: ["奇幻", "转生", "权谋"],
    episode: 76,
    updateDay: "每周六更新",
    cover: "https://readdy.ai/api/search-image?query=A%20grand%20epic%20fantasy%20webtoon%20cover%20illustration%20of%20a%20young%20prince%20climbing%20a%20mystical%20glowing%20staircase%20to%20heaven%20amid%20floating%20kingdoms%2C%20rich%20emerald%20and%20gold%2C%20majestic%20detailed%20cartoon%20style&width=600&height=860&seq=hanman-cover-10&orientation=portrait",
    shortDesc: "坠崖少年被选中为「登天者」,在万王纷争中逆天改命。",
    synopsis: "重生在架空大陆的佣兵少年韩景,被古老的天梯选中成为「登天者」。传说登顶天梯者可得万王之位。为守护并肩的同伴、为查清前世死因,他踏上这条步步惊心的权谋征途。宏大的世界观、烧脑的布局与爽快的成长并存。",
  },
  {
    id: 11,
    slug: "di-ti-mo-fa-zhen",
    title: "第七魔法阵",
    category: "fantasy",
    author: "苍术",
    status: "已完结",
    rating: 9.3,
    views: "2310万",
    likes: 6900,
    tags: ["奇幻", "魔法", "学院"],
    episode: 120,
    updateDay: "已完结",
    cover: "https://readdy.ai/api/search-image?query=A%20magical%20academy%20webtoon%20cover%20illustration%20of%20a%20young%20student%20casting%20a%20glowing%20complex%20magic%20circle%2C%20vibrant%20teal%20and%20indigo%20magic%20light%2C%20dynamic%20detailed%20cartoon%20style%2C%20wondrous%20atmosphere&width=600&height=860&seq=hanman-cover-11&orientation=portrait",
    shortDesc: "天资平庸的魔法学徒,因意外点亮早已失传的第七魔法阵。",
    synopsis: "魔法学院里,天赋平平的学徒洛洛一直不被看好。直到他在古书残页中,意外触发失传千年的「第七魔法阵」。那是一个连皇家魔导士都束手无策的禁忌之术。为了揭开阵法的秘密与学院的黑暗真相,他必须变得比任何人都强。",
  },
  {
    id: 12,
    slug: "zhi-zhi-mi-lv",
    title: "纸之密旅",
    category: "suspense",
    author: "折页人",
    status: "连载中",
    rating: 9.1,
    views: "1670万",
    likes: 5400,
    tags: ["悬疑", "都市", "超自然"],
    episode: 48,
    updateDay: "每周五更新",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20urban%20suspense%20webtoon%20cover%20illustration%20of%20a%20figure%20holding%20origami%20papers%20that%20turn%20into%20glowing%20birds%20in%20a%20foggy%20city%20night%2C%20charcoal%20and%20amber%2C%20enigmatic%20stylish%20cartoon%20style&width=600&height=860&seq=hanman-cover-12&orientation=portrait",
    shortDesc: "能折出「真相」的折纸师,被卷入都市怪谈与阴谋旋涡。",
    synopsis: "神秘的折纸师阿杳,能用折出的纸鸟追寻被隐藏的真相。当城市接连出现诡异的怪谈事件,警方束手无策时,阿杳的纸片开始指引方向。可越接近真相,她越发现,这些事件背后是一张更大的网。都市悬疑与超自然交织,层层反转。",
  },
  {
    id: 13,
    slug: "sheng-yu-ming-tian",
    title: "胜于明天",
    category: "drama",
    author: "晚风与麦",
    status: "连载中",
    rating: 9.2,
    views: "1420万",
    likes: 4800,
    tags: ["剧情", "励志", "竞技"],
    episode: 64,
    updateDay: "每周三更新",
    cover: "https://readdy.ai/api/search-image?query=A%20motivational%20drama%20webtoon%20cover%20illustration%20of%20a%20young%20athlete%20training%20hard%20at%20dawn%20on%20a%20running%20track%2C%20warm%20sunrise%20gold%20and%20blue%20sky%2C%20inspiring%20clean%20cartoon%20style%2C%20determined%20hopeful%20mood&width=600&height=860&seq=hanman-cover-13&orientation=portrait",
    shortDesc: "命运多舛的少年短跑选手,用每一步证明「明天由自己定义」。",
    synopsis: "因伤退役又遭家庭变故的少年运动员穆言,在几乎放弃时被一位固执的老教练捡起。没有天赋异禀,没有贵人相助,他只能靠日复一日的训练,把输掉的未来一寸寸赢回来。热血励志的竞技故事,看哭了无数读者。",
  },
  {
    id: 14,
    slug: "men-wai-di-xiang",
    title: "门外的蜜糖",
    category: "romance",
    author: "桃枝糖",
    status: "连载中",
    rating: 8.9,
    views: "1180万",
    likes: 3900,
    tags: ["恋爱", "邻居", "轻松"],
    episode: 42,
    updateDay: "每周二更新",
    cover: "https://readdy.ai/api/search-image?query=A%20playful%20romance%20webtoon%20cover%20illustration%20of%20two%20apartment%20neighbors%20meeting%20at%20their%20doors%20with%20a%20shared%20takeaway%20meal%2C%20bright%20warm%20pastel%20tones%2C%20cute%20fun%20cartoon%20style%2C%20lively%20romantic%20mood&width=600&height=860&seq=hanman-cover-14&orientation=portrait",
    shortDesc: "门对门的邻居,一份错拿的外卖,牵起了一场双向奔赴。",
    synopsis: "独居的加班族白桃,错拿了对门邻居的外卖,也顺带「错拿」了一段新生活。那位寡言的家教老师闻舟,白天是温柔先生,晚上是游戏高玩。两个生活节奏完全不同的邻居,在一次次外卖与夜宵的投喂中,逐渐向对方打开了门。",
  },
  {
    id: 15,
    slug: "di-yi-qi-xian",
    title: "第七宣言",
    category: "action",
    author: "极光零号",
    status: "连载中",
    rating: 9.0,
    views: "1950万",
    likes: 6100,
    tags: ["热血", "超能力", "群像"],
    episode: 68,
    updateDay: "每周日更新",
    cover: "https://readdy.ai/api/search-image?query=A%20group%20superhero%20action%20webtoon%20cover%20illustration%20of%20a%20team%20of%20superpowered%20youths%20standing%20together%20against%20a%20storm%20sky%2C%20electric%20orange%20and%20teal%20energy%2C%20bold%20dynamic%20cartoon%20style%2C%20epic%20rally%20mood&width=600&height=860&seq=hanman-cover-15&orientation=portrait",
    shortDesc: "七名觉醒超能力的少年,为守护「普通人的明天」而战。",
    synopsis: "一场全球性的「异能觉醒」后,七名普通少年因缘际会被聚集在秘密组织「第七」旗下。有人想保护家人,有人想复仇,有人只想逃离。但当更大的威胁降临,他们必须放下分歧,共同兑现「第七宣言」——为守护那些无法自保的人而战。",
  },
  {
    id: 16,
    slug: "qing-feng-ming-yue",
    title: "清风明月",
    category: "drama",
    author: "一川烟",
    status: "已完结",
    rating: 9.6,
    views: "4470万",
    likes: 15600,
    tags: ["剧情", "武侠", "情感"],
    episode: 136,
    updateDay: "已完结",
    cover: "https://readdy.ai/api/search-image?query=A%20poetic%20wuxia%20drama%20webtoon%20cover%20illustration%20of%20a%20swordswoman%20and%20a%20gentle%20scholar%20under%20a%20moonlit%20pine%20tree%2C%20misty%20emerald%20and%20ink%20wash%20palette%2C%20elegant%20traditional%20cartoon%20style%2C%20serene%20melancholic%20mood&width=600&height=860&seq=hanman-cover-16&orientation=portrait",
    shortDesc: "江湖儿女与温柔书生,一场跨越家仇恩怨的倾世之恋。",
    synopsis: "背负灭门之仇的剑客柳青霜,在追杀仇人的途中被温润如玉的书生江明远所救。身份对立的两人,在一次次患难与共中萌生情愫。当真相揭开、恩怨交织,这份感情该何去何从。画风清雅、情感细腻的武侠剧情神作,口碑封神。",
    featured: true,
  },
];

export const getWebtoon = (slug: string): Webtoon | undefined =>
  webtoons.find((w) => w.slug === slug);

export const getWebtoonsByCategory = (slug: string): Webtoon[] =>
  webtoons.filter((w) => w.category === slug);

export const topRated = (): Webtoon[] =>
  [...webtoons].sort((a, b) => b.rating - a.rating);

export const featuredList = (): Webtoon[] =>
  webtoons.filter((w) => w.featured);